<template>
  <div>
    <el-form-item class="bg-white form-item-card" label="个人信息" v-if="userInfo.tel && isValidLoginState">
      <span class="vivo-form-item-lable fl text-muted">联系方式</span>
      <el-form-item class="fl" prop="userName">
        <label class="name-label">姓名：</label>
        <h-input
          placeholder="输入您的姓名"
          v-model.trim="orderForm.userName"
          @input="validateField('userName')"></h-input>
      </el-form-item>
      <el-form-item class="fl" prop="tel">
        <label class="name-label">联系电话：</label>
        <h-input
          placeholder="手机号码"
          v-model.trim="userInfo.tel"
          readonly
          @input="validateField('tel')"></h-input>
      </el-form-item>
    </el-form-item>

    <el-form-item class="bg-white form-item-card card-form-item--contact" label="个人信息" v-else>
      <div class="clearfix field-item">
        <p class="vivo-form-item-lable text-muted">联系姓名</p>
        <el-form-item prop="userName">
          <h-input
            placeholder="输入您的姓名"
            v-model.trim="orderForm.userName"
            @input="validateField('userName')"></h-input>
        </el-form-item>
      </div>
      <div class="clearfix field-item">
        <span class="vivo-form-item-lable text-muted">联系电话</span>
        <el-form-item prop="tel">
          <h-input placeholder="手机号码" v-model.trim="loginTel"></h-input>
          <h-button
            class="right-button"
            :disabled="isGetSmsCodeButtonDisabled"
            @click="doGetCode">{{ isCounting ? count + 's后获取' : '获取验证码'}}</h-button>
        </el-form-item>
      </div>
      <div class="clearfix field-item">
        <span class="vivo-form-item-lable text-muted">验证码</span>
        <el-form-item prop="tel">
          <h-input placeholder="请输入短信验证码" v-model.trim="loginSmsCode"></h-input>
        </el-form-item>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import { FormItem, Message } from 'element-ui';
import hInput from '@/components/input';
import hButton from '@/components/button';
import hsbLogin from '@/core/login/hsbLogin';
import { checkLoginStatus } from '@/apis/base';

export default {
  mixins: [hsbLogin],
  props: {
    validateField: Function,
    orderForm: Object
  },
  components: {
    hInput,
    hButton,
    [FormItem.name]: FormItem
  },
  data () {
    return {
      isValidLoginState: false
    };
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo;
    }
  },
  watch: {
    loginSmsCode (val) {
      if (val.length === 6) {
        this.doLogin();
      }
    },
    userInfo (val) {
      if (val && val.tel) {
        this.orderForm.tel = val.tel;
      }
      this.updateLoginState();
    }
  },
  methods: {
    loginAfter (token, userInfo) {
      if (userInfo) {
        this.$store.commit('user/setUserInfo', {
          tel: userInfo.tel,
          openid: userInfo.openid
        });
      }
      this.$store.commit('user/setToken', token, this.expires);
    },
    updateLoginState () {
      checkLoginStatus().then(res => {
        if (res.success) {
          this.isValidLoginState = +res._data.status === 1;
        } else {
          Message.error(res._errStr);
        }
      }).catch(err => {
        Message.error(err);
      });
    }
  },
  mounted () {
    this.updateLoginState();
  }
};
</script>

<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/createOrder/FormContact.vue